import { useMutation } from 'react-query';
import axios from 'axios';
import { CategoriesTopicsTableAPI } from '../../../constants/API';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { QueueItemIconMedia } from '../../../types/Admin/ItemIconTypes';

export const useUploadTopicChildrenIcon = (topicId?: number | null) => {
  const { mutateAsync: uploadTopicChildrenIcon, isLoading: isUploadTopicChildrenIconLoading } =
    useMutation(async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const url = topicId
        ? CategoriesTopicsTableAPI.uploadTopicChildrenIcon(topicId)
        : CategoriesTopicsTableAPI.uploadPendingTopicChildrenIcon;
      const response = await axios.post<QueueItemIconMedia>(url, formData, multipartHeaders());
      return response.data.url;
    });

  return { uploadTopicChildrenIcon, isUploadTopicChildrenIconLoading };
};
